module.exports = __webpack_public_path__ + "static/media/LB_03.1ec74e73.jpg";